const localWindow = globalThis as typeof globalThis & {env: Record<string, string>};

export const environment = {
    backendBaseUrl: localWindow?.env ? localWindow.env['backendBaseUrl'] : 'http://127.0.0.1:5002/',
    oo8EventBaseUrl: localWindow?.env ? localWindow.env['oo8EventBaseUrl'] : 'ws://localhost:6001/',
    appEnvironment: localWindow?.env ? localWindow.env['appEnvironment'] : 'development'
};
